/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';
import PersonActions from 'shared/ui/components/fp-type-display/PersonActions.vue';
import PersonActivityFeed from 'shared/ui/components/fp-type-display/PersonActivityFeed.vue';
import PersonPhoto from 'shared/ui/components/fp-type-display/PersonPhoto.vue';
import PersonSessionStats from 'shared/ui/components/fp-type-display/PersonSessionStats.vue';
import * as metaUtils from 'libs/utils/metadata';

const __vue_script__ = {
    name: 'Person',

    components: {
        MetaForm,
        PersonActions,
        PersonActivityFeed,
        PersonSessionStats,
        PersonPhoto,
    },

    props: {
        params: {
            type: Object,
            default: () => {},
        }
    },

    data() {
        return {
            eid: undefined,
            pid: undefined,
            doc: {},
            fields: [],
            metadata: {},
            timeline: [],
        };
    },

    computed: {
        isShowHiddenFields() {
            return this.metadata?._display_hidden_fields || false;
        }
    },

    async mounted() {
        this.eid = this.params.event._id;
        this.metadata = await this.$services.metadata.getMetadataForType(this.eid, 'person');
        this.fields = metaUtils.convertMetadataHashToOrderedList(this.metadata);
        await this.getPerson();
    },

    methods: {
        /** @param {FieldDescriptor[]} fields */
        async getPerson() {
            try {
                const defaults = await this.$utils.controls.extractDefaults(this.fields, this.$services);
                const { participantId: pid } = this.$router.getRouteParams();

                if (!pid) {
                    this.doc = defaults;
                    return;
                }

                const doc = await this.$services.pax.getPaxInfoWithTimeline(this.eid, pid);
                if (doc.fp_type !== 'person') {
                    throw new Error(`doc ${this.doc._id} is not a person`);
                }

                this.pid = pid;

                for (const field of this.fields) {
                    if (!doc.hasOwnProperty(field.field)) {
                        doc[field.field] = defaults[field.field];
                    }
                }

                this.timeline = doc.timeline;
                delete doc.timeline;
                this.doc = doc;
            } catch (err) {
                console.error('[PersonDisplay] could not get person doc', err);
            }
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-display" },
    [
      _vm.doc
        ? _c("meta-form", {
            attrs: {
              "fp-type": "person",
              edit: _vm.doc.hasOwnProperty("_id"),
              event: _vm.params.event,
              fields: _vm.fields,
              "show-hidden-fields": _vm.isShowHiddenFields,
              "show-fp-ext-id": false,
              "show-toolbar": true,
              value: _vm.doc,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "secondary-panel-top",
                  fn: function (ref) {
                    return [
                      _vm.doc && _vm.doc.fp_ext_id
                        ? _c("person-photo", {
                            attrs: {
                              event: _vm.params.event,
                              "user-doc": _vm.doc,
                            },
                          })
                        : _vm._e(),
                      _vm.doc && _vm.doc.fp_ext_id && _vm.eid
                        ? _c("h3", [
                            _vm._v(_vm._s(_vm.$t("user_display.quick_stats"))),
                          ])
                        : _vm._e(),
                      _vm.doc && _vm.doc.fp_ext_id && _vm.eid
                        ? _c("person-session-stats", {
                            attrs: {
                              "fp-ext-id": _vm.doc.fp_ext_id,
                              eid: _vm.eid,
                            },
                          })
                        : _vm._e(),
                      _vm.doc && _vm.doc.fp_ext_id && _vm.eid
                        ? _c("h3", [
                            _vm._v(_vm._s(_vm.$t("user_display.actions"))),
                          ])
                        : _vm._e(),
                      _vm.doc && _vm.doc.fp_ext_id && _vm.eid
                        ? _c("person-actions", {
                            attrs: {
                              branding: _vm.params.event.branded_app,
                              event: _vm.params.event,
                              "user-doc": _vm.doc,
                            },
                          })
                        : _vm._e(),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("general.settings")))]),
                    ]
                  },
                },
              ],
              null,
              false,
              2260963383
            ),
          })
        : _vm._e(),
      _vm.timeline && _vm.timeline.length
        ? _c("h3", [_vm._v(_vm._s(_vm.$t("user_display.activity_feed")))])
        : _vm._e(),
      _vm.timeline && _vm.timeline.length
        ? _c("person-activity-feed", {
            attrs: {
              eid: _vm.params.event._id,
              pid: _vm.doc._id,
              timeline: _vm.timeline,
              timezone: _vm.params.event.timezone,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/types/Person.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__